import { render, staticRenderFns } from "./GridPostContent.vue?vue&type=template&id=cbc4d9d2&scoped=true&"
import script from "./GridPostContent.vue?vue&type=script&lang=js&"
export * from "./GridPostContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc4d9d2",
  null
  
)

export default component.exports